export interface LandingConfig {
  siteUrl: string;
  formEndpoint: string;
  formSource: string;
  salesEmail: string;
}

const fromEnv: LandingConfig = {
  siteUrl: (import.meta.env.VITE_SITE_URL || 'https://irisglobal.io').replace(/\/$/, ''),
  formEndpoint: import.meta.env.VITE_FORM_ENDPOINT || 'https://irisglobal.io/api/v1/onboarding-requests',
  formSource: import.meta.env.VITE_FORM_SOURCE || 'banner',
  salesEmail: import.meta.env.VITE_SALES_EMAIL || 'sales@solacetech.group',
};

export const config: LandingConfig = { ...fromEnv };

function pick(raw: Record<string, unknown> | undefined): Partial<LandingConfig> {
  if (!raw) return {};
  const out: Partial<LandingConfig> = {};
  for (const key of ['siteUrl', 'formEndpoint', 'formSource', 'salesEmail'] as const) {
    const value = raw[key];
    if (typeof value === 'string' && value.trim()) {
      out[key] = key === 'siteUrl' ? value.trim().replace(/\/$/, '') : value.trim();
    }
  }
  return out;
}

/** Runtime overrides: window.__IRIS_LANDING__, then /config.json. */
export async function loadConfig(): Promise<LandingConfig> {
  Object.assign(config, fromEnv, pick(window.__IRIS_LANDING__));
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}config.json`, { cache: 'no-store' });
    if (res.ok) Object.assign(config, pick(await res.json()));
  } catch {
    /* static hosts without config.json keep env defaults */
  }
  Object.assign(config, pick(window.__IRIS_LANDING__));
  return config;
}

export function origin(): string {
  return config.siteUrl.replace(/\/$/, '');
}

/** Shared site taxonomy for the form, home lists and line pages. */
export const SITE_TYPES = [
  'residential_compound',
  'hotel',
  'mall',
  'hospital',
  'office',
  'factory',
  'city',
  'other',
] as const;

export type SiteType = (typeof SITE_TYPES)[number];

export const PLACEMENTS = ['indoor', 'outdoor', 'both'] as const;
export type Placement = (typeof PLACEMENTS)[number];

export const CONNECTIONS = ['unsure', '4g', 'wifi', 'ethernet', 'rf'] as const;
export type Connection = (typeof CONNECTIONS)[number];
